"use client";

import React from "react";
import IconText from "@/components/featured/common/cards/IconText";

export default function IconTextCard({ item, ...restProps }) {
  if (!item) return null;

  return (
    <IconText
      {...item}
      {...restProps}
    />
  );
}
